function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.6974 10.8028L24.0761 11.5076L24.8469 11.2928C25.5308 11.1022 26.2526 11 27 11C31.4183 11 35 14.5817 35 19C35 23.4183 31.4183 27 27 27H14C7.92487 27 3 22.0751 3 16C3 9.92487 7.92487 5 14 5C18.1937 5 21.8408 7.34643 23.6974 10.8028Z",
  stroke: "#CCCCCC",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13 25C13 29.9706 17.0294 34 22 34H32C35.3137 34 38 31.3137 38 28C38 24.6863 35.3137 22 32 22C31.4994 22 31.0132 22.0613 30.5483 22.1768C29.3641 18.5892 25.9844 16 22 16C17.0294 16 13 20.0294 13 25Z",
  fill: "#CDDCE8",
  fillOpacity: 0.84
});

var SvgCloudy = function SvgCloudy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloudy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cloudy.418a8228.svg";
export { ForwardRef as ReactComponent };